const subscriptionES = {
    "view": {
        "table": {
            "title": "Tu Suscripción",
            "column": {
                "subscriptionTier": "Nivel de Suscripción",
                "startDate": "Fecha de Inicio",
                "currentPeriodStart": "Inicio del Período Actual",
                "currentPeriodEnd": "Fin del Período Actual",
                "autoRenewal": "Renovación Automática",
                "status": "Estado",
                "action": "Acción"
            },
            "label": {
                "status_active": "Activo",
                "status_incomplete": "Incompleto",
                "status_incomplete_expired": "Incompleto Expirado",
                "status_unpaid": "No Pagado",
                "status_past_due": "Vencido",
                "status_cancelled": "Cancelado",
                "status_expired": "Expirado"
            },
            "actionDropdown": {
                "label": {
                    "action": "Acción"
                },
                "button": {
                    "enableAutoRenewal": "Habilitar Renovación Automática",
                    "upgradeSubscription": "Actualizar Suscripción",
                    "cancelSubscription": "Cancelar Suscripción",
                    "resumeSubscription": "Reanudar Suscripción",
                    "retryPayment": "Reintentar Pago"
                },
                "message": {
                    "successSubscripionResumed": "Tu suscripción ha sido reanudada, ¡tu cuenta se actualizará en breve!",
                    "successSubscripionCancelled": "¡Tu suscripción se ha configurado para ser cancelada al final del período!",
                    "successSubscripionAutoRenewalEnabled": "¡Tu suscripción se ha configurado para renovarse automáticamente al final del período!",
                    "activeSubscription": "Ya tienes una suscripción activa",
                    "incompleteSubscription": "Tienes una suscripción que está Incompleta."
                }
            },
            "modal": {
                "button": {
                    "cancel": "Cancelar",
                    "enableAutoRenewal": "Habilitar renovación automática",
                    "cancelSubscription": "Cancelar suscripción"
                }
            }
        },
        "modal": {
            "enableAutoRenewal": {
                "header": "Habilitar Renovación Automática",
                "body": "¿Estás seguro de que deseas habilitar la renovación automática para tu suscripción?"
            },
            "cancel": {
                "header": "Cancelar Suscripción",
                "body": "¿Estás seguro de que deseas cancelar tu suscripción?"
            },
            "resume": {
                "header": "Reanudar Suscripción",
                "body": {
                    "description": "¿Estás seguro de que deseas reanudar la suscripción?",
                    "note": "<strong>Nota:</strong> ¡Se aplicará el precio más reciente de la suscripción!"
                },
                "button": {
                    "cancel": "Cancelar",
                    "resume": "Reanudar"
                },
                "message": {
                    "error": "¡Algo salió mal! ¡Por favor, actualiza la página e inténtalo de nuevo!"
                }
            },
            "retryPayment": {
                "header": "Reintentar Pago de Suscripción",
                "body": {
                    "description": "¿Estás seguro de que deseas reintentar el pago de la suscripción?",
                    "note": "<strong>Nota:</strong> ¡Se aplicará el precio más reciente de la suscripción!"
                },
                "button": {
                    "cancel": "Cancelar",
                    "retry": "Reintentar"
                },
                "message": {
                    "error": "¡Algo salió mal! ¡Por favor, actualiza la página e inténtalo de nuevo!"
                }
            }
        },
        "message": {
            "errorPaymentFailed": "El pago de la suscripción falló, ¡por favor intenta de nuevo más tarde!",
            "errorCardExpired": "Tu tarjeta ha expirado. Por favor, añade un <1>método de pago</1> válido y vuelve a intentar el pago.",
            "errorNoPaymentMethod": "No tienes ningún <1>método de pago</1> añadido a tu perfil. Por favor, añade un <3>método de pago</3> válido y vuelve a intentar el pago.",
            "moduleNoAccess": "No tienes acceso a este módulo, por favor contacta al equipo de soporte para más información."
        }
    },
    "subscriptionTiers": {
        "form": {
            "title": "Elige Tu Plan",
            "button": {
                "startNow": "Comenzar Ahora"
            }
        },
        "message": {
            "error": "¡Algo salió mal! ¡Por favor, actualiza la página e inténtalo de nuevo!"
        }
    },
    "upgrade": {
        "form": {
            "title": "Actualiza Tu Suscripción",
            "button": {
                "upgrade": "Actualizar",
                "currentPlan": "Plan Actual"
            }
        },
        "modal": {
            "upgradeSubscription": {
                "header": "Actualizar Suscripción",
                "body": {
                    "description": "¿Estás seguro de que deseas actualizar tu plan de suscripción a <strong>{{newTierName}}</strong>.",
                    "note": "<strong>Nota: El período de facturación de la suscripción permanecerá sin cambios y solo se te facturará el monto excluyendo lo que ya has pagado por el plan existente.</strong>"
                },
                "button": {
                    "cancel": "Cancelar",
                    "confirm": "Confirmar"
                }
            }
        },
        "message": {
            "error": "¡Algo salió mal! ¡Por favor, actualiza la página e inténtalo de nuevo!",
            "moduleNoAccess": "No tienes acceso a este módulo, por favor contacta al equipo de soporte para más información."
        }
    },
    "confirmModal": {
        "header": "Confirma Tu Información",
        "body": {
            "form": {
                "label": {
                    "firstName": "Nombre",
                    "lastName": "Apellido",
                    "country": "País de Residencia",
                    "refundPolicyAgreement": "Al continuar, reconozco y acepto que este pago es final y no reembolsable. <1>Política de reembolso</1>",
                },
                "help_text": {
                    "firstName": "Por favor, confirma que este es tu Nombre Legal.",
                    "lastName": "Por favor, confirma que este es tu Apellido Legal.",
                    "country": "Por favor, especifica tu país de residencia actual."
                },
                "message": {
                    "error": "¡Ocurrió un error al crear la suscripción!",
                    "note": "Nota: La precisión de la información que proporciones aquí es esencial para los pasos posteriores. Asegúrate de que toda la información se proporcione de manera precisa y veraz."
                }
            }
        },
        "button": {
            "cancel": "Cancelar",
            "confirm": "Confirmar"
        }
    },
    "upgradeFailure": {
        "view": {
            "title": "Actualización de Suscripción Fallida :(",
            "description": "Hubo un problema al actualizar tu suscripción. ¡Por favor, intenta de nuevo más tarde!",
            "button": {
                "returnToDashboard": "Volver al Panel"
            }
        }
    },
    "upgradeSuccess": {
        "view": {
            "title": "Suscripción Actualizada :)",
            "description": "Has actualizado tu suscripción con éxito, ¡tu cuenta se actualizará en breve!",
            "button": {
                "returnToDashboard": "Volver al Panel"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transacción Cancelada :(",
            "description": "La transacción fue cancelada... ¡Por favor, intenta de nuevo más tarde!",
            "button": {
                "returnToDashboard": "Volver al Panel"
            }
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transacción Exitosa :)",
            "description": "Has confirmado tu suscripción con éxito, ¡tu cuenta se actualizará en breve!",
            "button": {
                "returnToDashboard": "Volver al Panel"
            }
        }
    }
};

export default subscriptionES;